module.exports = __webpack_public_path__ + "img/cover28.988af163.png";